/**
 * Controls when the site-wide newsletter popup appears: after a time delay or a
 * scroll percentage, whichever happens first. Shows at most once per browser
 * session, and stays suppressed for a configurable number of days after the
 * visitor closes it or subscribes. Markup and open/close behavior live in
 * sections/newsletter-popup.liquid + the shared dialog-component (dialog.js).
 */
(function () {
  var DISMISSED_UNTIL_KEY = 'winnowo:newsletter-popup:dismissed-until';
  var SUBSCRIBED_KEY = 'winnowo:newsletter-popup:subscribed';
  var SESSION_KEY = 'winnowo:newsletter-popup:shown-session';

  function isSuppressed() {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return true;
      if (localStorage.getItem(SUBSCRIBED_KEY)) return true;

      var dismissedUntil = localStorage.getItem(DISMISSED_UNTIL_KEY);
      if (dismissedUntil && Date.now() < Number(dismissedUntil)) return true;

      // Best-effort: skip for visitors who arrived from an email marketing link.
      var params = new URLSearchParams(window.location.search);
      if (params.get('utm_medium') === 'email' || params.get('utm_source') === 'email') return true;
      var emailToolParams = ['klaviyo', 'omnisend', 'mc_cid', 'mc_eid'];
      for (var i = 0; i < emailToolParams.length; i++) {
        if (params.has(emailToolParams[i])) return true;
      }
    } catch (error) {
      // Storage may be unavailable (privacy mode, etc.) — fail open and allow the popup.
    }
    return false;
  }

  function markSessionShown() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (error) {}
  }

  function init() {
    var root = document.getElementById('newsletter-popup');
    if (!root || typeof root.showDialog !== 'function') return;

    var justPosted = root.dataset.justPosted === 'true';
    var justSubscribed = root.dataset.justSubscribed === 'true';

    if (justSubscribed) {
      try {
        localStorage.setItem(SUBSCRIBED_KEY, '1');
      } catch (error) {}
    }

    // The customer form is a full page post/reload. If this load is the result of
    // that submission (success or validation error), reopen immediately to show
    // the message instead of waiting for the normal trigger.
    if (justPosted) {
      markSessionShown();
      root.showDialog();
      return;
    }

    if (isSuppressed()) return;

    var delayMs = Number(root.dataset.delaySeconds || 9) * 1000;
    var scrollPercentage = Number(root.dataset.scrollPercentage || 30);
    var suppressionDays = Number(root.dataset.suppressionDays || 10);
    var triggered = false;
    var timerId;

    function trigger() {
      if (triggered) return;
      triggered = true;
      clearTimeout(timerId);
      window.removeEventListener('scroll', onScroll);
      markSessionShown();
      root.showDialog();
    }

    function onScroll() {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var scrolledPercentage = (window.scrollY / scrollable) * 100;
      if (scrolledPercentage >= scrollPercentage) trigger();
    }

    timerId = setTimeout(trigger, delayMs);
    window.addEventListener('scroll', onScroll, { passive: true });

    root.addEventListener('dialog:close', function () {
      try {
        var expiry = Date.now() + suppressionDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(DISMISSED_UNTIL_KEY, String(expiry));
      } catch (error) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
